export default {
  es: {
    UPDATED_AT: 'Actualizado el',
    OFFER_END_IN: '¡La oferta termina en',
    I_WANT_IT: 'Lo deseo',
    REMOVE: 'Remover',
    SHARE: 'Compartir',
    SHARE_FREE_COURSE: 'Compártelo con tus amigos',
    ADD: 'Agregar',
    GIFT: 'Regalar',
    REQUIREMENTS_TITLE: '¿Qué necesito para aprender a {{friendlyTitle}}?',
    REQUIREMENTS_TITLE_2: '¿Qué necesito?',
    ABOUT_TITLE: '¿De qué trata este curso?',
    SHOW_CONTENT: 'Mostrar contenido',
    HIDE_CONTENT: 'Ocultar contenido',
    LESSONS_SECTION_TITLE: 'Temario del curso',
    LEVEL_REQUIREMENTS_TITLE: 'Curso de nivel {{level}}',
    SHOW_ALL_LESSONS: 'Mostrar todo el temario',
    HIDE_ALL_LESSONS: 'Ocultar todo el temario',
    FEATURED_REVIEW_TITLE: 'Reseña destacada',
    REVIEWS_TITLE: 'Valoraciones',
    TOTAL_SCORE: 'Media total',
    LOAD_MORE_REVIEWS: 'Mostrar más comentarios',
    WATCH_TRAILER: 'Mira el trailer',
    BUY_NOW: 'Comprar ahora',
    ENROLL_NOW: 'Inscribete ahora',
    YEARLY: 'Al año',
    BECOME_PREMIUM: 'Vuélvete Premium',
    PREMIUM_COPY: 'Forma parte de nuestra comunidad Premium',
    BUY_FRECUENTLY: 'Comprados frecuentemente',
    BEST_SELLER: 'Más vendido',
    NEW: 'Nuevo',
    STUDENTS: 'Estudiantes',
    FAQ_TITLE: 'Preguntas frecuentes',
    FAQ_QUESTION1_TITLE: '¿Tengo acceso ilimitado a las clases?',
    FAQ_QUESTION1_TEXT:
      '¡Si! Luego de que te inscribas al curso, vas a poder tener acceso ilimitado a las clases. El curso se queda en tu cuenta de Crehana para siempre.',
    FAQ_QUESTION1_TEXT_PAY:
      '¡Sí! Luego de que realices la compra vas a poder acceder a las clases cuando y donde quieras. El curso se queda en tu cuenta de Crehana para siempre. :)',
    FAQ_QUESTION2_TITLE: '¿Cuándo inicia el curso?',
    FAQ_QUESTION2_TEXT:
      'Todo el contenido es 100% en línea, con clases pregrabadas a las que tendrás acceso de manera ilimitada. ¡Puedes iniciarlo y desarrollarlo a tu propio ritmo!',
    FAQ_QUESTION2_TEXT_PAY:
      'Todo el contenido es 100% en línea, con clases pregrabadas a las que tendrás acceso luego de la compra del curso. ¡Puedes iniciarlo y desarrollarlo a tu propio ritmo!',
    FAQ_QUESTION3_TITLE: '¿Los cursos gratis tienen diploma?',
    FAQ_QUESTION3_TITLE_PAY: '¿Cómo obtengo el diploma del curso?',
    FAQ_QUESTION3_TEXT:
      'Para poder obtener un diploma, debes de inscribirte a un curso de paga. Puedes revisar nuestro catálogo',
    FAQ_QUESTION3_TEXT_PAY:
      'Luego de que termines el curso, debes de desarrollar el proyecto final y publicarlo con la comunidad desde la sección "Tu proyecto final". Los mentores del curso y el equipo de Crehana lo revisarán y si todo va bien, se te emite el diploma para que lo descargues desde tu panel de estudiante.',
    SEO_TITLE: 'Curso online de',
    SHOW_MORE: 'Mostrar más',
    SHOW_LESS: 'Mostrar menos',
    ACHIEVEMENT_TITLE: '¿Qué aprenderás en este curso online de ',
    INFO_SECTION_TITLE: 'Información del curso',
    TOTAL_LESSONS_TEXT: ' clases de acceso ilimitado',
    TOTAL_DURATION: 'Duración:',
    TOTAL_ATTACHMENTS_TEXT: ' Archivos adjuntos',
    CERTIFIES_TEXT: 'Certifícate al terminar',
    PROJECTS_TITLE: 'Proyectos de Estudiantes',
    TEMPORAL_ACCESS: '¡Acceso gratis por 24hrs!',
    TRY_COURSE: '¡Pruébalo gratis!',
    PREMIUM_ACCCES: 'ACCESO PREMIUM',
    FREE_SUBSCRIPTION: '¡INSCRÍBETE GRATIS!',
    SUBSCRIBE_NOW: '¡INSCRÍBETE AHORA!',
    TURN_PREMIUM: 'Vuévete Premium',
    REMOVING: 'Quitando...',
    ADDED: 'Agregado',
    ADDING: 'Agregando',
    ADD_TO_CART: 'Agregar a mi carrito',
    SHARE_DIALOG_TITLE: 'Recomienda este curso a tus amigos',
    GO_TO_COURSE: 'Ir al curso',
    VALID_ONLY: '*Válido por 24hrs solo para nuevos usuarios',
    FREE_TRIAL: 'Pruébalo sin costo',
  },
};
